import apiWrapper from '@/helpers/apiWrapper';
import type { IFAQGetParams, IFAQItemGetResponse } from '@/types/faq';

export default {
  get: (
    params?: IFAQGetParams,
  ) => apiWrapper.get<IFAQItemGetResponse>('/api/v1/faq', { params }),
};
